module.exports = __webpack_public_path__ + "img/reverse-warning.952d3909.svg";